import { rect, cRect, px } from '../../../pixel/canvas';
import { SLOT } from '../slots';
import type { Hull } from '../../types';

export const bird: Hull = {
  id: 'bird',
  name: 'Bird',
  baseStats: { ferocity: 10, agility: 35, arcane: 25, resilience: 10, stealth: 15 },
  drawBody: (ctx, p) => {
    // Head (round-ish, top of body)
    cRect(ctx, 12, 12, 8, p.primary);
    cRect(ctx, 12, 12, 1, p.light);
    cRect(ctx, 19, 12, 1, p.shadow);
    // Beak (small triangle pointing down)
    cRect(ctx, 18, 4, 2, p.detail);
    cRect(ctx, 19, 2, 1, p.dark);
    // Eyes (front-facing)
    px(ctx, 28, 16, p.dark);
    px(ctx, 35, 16, p.dark);
    // Body trunk (oval-ish, narrower at hips)
    cRect(ctx, 21, 16, 16, p.primary);
    cRect(ctx, 21, 16, 1, p.light);
    cRect(ctx, 36, 16, 1, p.shadow);
    // Chest accent
    cRect(ctx, 25, 6, 6, p.accent);
    // Wings folded along body sides — symmetric
    rect(ctx, 16, 22, 4, 14, p.shadow);
    rect(ctx, 16, 22, 1, 14, p.dark);
    rect(ctx, 16, 22, 4, 1, p.dark);
    rect(ctx, 44, 22, 4, 14, p.shadow);
    rect(ctx, 47, 22, 1, 14, p.dark);
    rect(ctx, 44, 22, 4, 1, p.dark);
    // Wing feather lines (3 horizontal stripes per wing)
    rect(ctx, 16, 26, 4, 1, p.dark);
    rect(ctx, 16, 30, 4, 1, p.dark);
    rect(ctx, 16, 34, 4, 1, p.dark);
    rect(ctx, 44, 26, 4, 1, p.dark);
    rect(ctx, 44, 30, 4, 1, p.dark);
    rect(ctx, 44, 34, 4, 1, p.dark);
    // Tail feathers (extending below)
    cRect(ctx, 38, 8, 4, p.shadow);
    cRect(ctx, 38, 8, 1, p.dark);
    cRect(ctx, 41, 6, 1, p.dark);
    // Legs/talons
    rect(ctx, 28, 42, 2, 6, p.trim);
    rect(ctx, 34, 42, 2, 6, p.trim);
    // Talons (claw-like)
    rect(ctx, 27, 47, 4, 2, p.detail);
    rect(ctx, 33, 47, 4, 2, p.detail);
  },
  mounts: {
    [SLOT.CRANIUM]: { anchor: { x: 32, y: 14 } },
    [SLOT.BACK]:    { anchor: { x: 32, y: 28 } },
    [SLOT.TAIL]:    { anchor: { x: 32, y: 44 } },
  },
};
